import React, { Component } from 'react'
import { RenderTenantList } from './utils/RenderTenantList'
import { ParseTenantInfo } from './utils/ParseTenantInfo'

export default class ComplianceRequirements extends Component {
  constructor(props) {
    super(props)

    this.requirements = {
      confidentialitySecret: [],
      confidentialityConfidential: [],
      availabilityCritical: [],
      continuityCritical: [],
    }
  }

  getRequirements = () => {
    const { allTenants } = this.props

    this.requirements = {
      confidentialitySecret: [],
      confidentialityConfidential: [],
      availabilityCritical: [],
      continuityCritical: [],
    }

    Object.keys(allTenants).forEach((acronym) => {
      const tenant = allTenants[acronym]

      if (tenant.status === 'active') {
        if (tenant.confidentiality === 'secret') {
          this.requirements.confidentialitySecret.push(ParseTenantInfo(tenant))
        }

        if (tenant.confidentiality === 'confidential') {
          this.requirements.confidentialityConfidential.push(
            ParseTenantInfo(tenant),
          )
        }

        if (tenant.availability === 'critical') {
          this.requirements.availabilityCritical.push(ParseTenantInfo(tenant))
        }

        if (tenant.continuity === 'critical') {
          this.requirements.continuityCritical.push(ParseTenantInfo(tenant))
        }
      }
    })
  }

  render = () => {
    const { allTenants } = this.props

    this.getRequirements()

    if (allTenants && Object.keys(allTenants).length === 0) {
      return (
        <div className="page-body__section">
          <div className="loader-container">
            <wb-spinner mode="dark" />
          </div>
        </div>
      )
    }

    return (
      <div className="page-body__section">
        <h3 className="wb-type-heading-m page-body__margin-bottom-s">
          Tenants with critical compliance requirements
        </h3>

        <wb-accordion theme="light" prevent-mobile-flyout>
          <RenderTenantList
            title="Confidentiality - Secret"
            list={this.requirements.confidentialitySecret}
          />
          <RenderTenantList
            title="Confidentiality - Confidential"
            list={this.requirements.confidentialityConfidential}
          />
          <RenderTenantList
            title="Availability - Critical"
            list={this.requirements.availabilityCritical}
          />
          <RenderTenantList
            title="Continuity - Critical"
            list={this.requirements.continuityCritical}
          />
        </wb-accordion>
      </div>
    )
  }
}
